import { httpService } from "./httpService";

export interface RMCTerms {
  id: number;
  proposalPropertyMappingId: number;
  termsAndConditions: string;
  createdDate?: string;
  modifiedDate?: string;
}

export interface RMCTermsCreateDto {
  proposalPropertyMappingId: number;
  termsAndConditions: string;
}

class RMCTermsService {
  private baseUrl = "/api/RMCTerms";

  async getAll(): Promise<RMCTerms[]> {
    return await httpService.get<RMCTerms[]>(
      `${this.baseUrl}/GetAll`,
      undefined,
      { unwrap: true, normalize: false, toast: false }
    );
  }

  async getById(id: number): Promise<RMCTerms> {
    return await httpService.get<RMCTerms>(
      `${this.baseUrl}/GetById/${id}`,
      undefined,
      { unwrap: true, normalize: false, toast: false }
    );
  }

  async getByProposalPropertyMappingId(
    proposalPropertyMappingId: number
  ): Promise<RMCTerms[]> {
    return await httpService.get<RMCTerms[]>(
      `${this.baseUrl}/GetByProposalPropertyMappingId/${proposalPropertyMappingId}`,
      undefined,
      { unwrap: true, normalize: false, toast: false }
    );
  }

  async createBulk(terms: RMCTermsCreateDto[]): Promise<RMCTerms[]> {
    return await httpService.post<RMCTerms[]>(
      `${this.baseUrl}/CreateBulk`,
      terms,
      undefined,
      { unwrap: true, normalize: false, toast: true }
    );
  }

  async create(term: RMCTermsCreateDto): Promise<RMCTerms> {
    return await httpService.post<RMCTerms>(
      `${this.baseUrl}/Create`,
      term,
      undefined,
      { unwrap: true, normalize: false, toast: true }
    );
  }

  async update(id: number, term: RMCTermsCreateDto): Promise<RMCTerms> {
    return await httpService.put<RMCTerms>(
      `${this.baseUrl}/Update/${id}`,
      term,
      undefined,
      { unwrap: true, normalize: false, toast: true }
    );
  }

  async deleteById(id: number): Promise<boolean> {
    await httpService.delete<void>(`${this.baseUrl}/Delete/${id}`, undefined, {
      unwrap: true,
      normalize: false,
      toast: true,
    });
    return true;
  }
}

export const rmcTermsService = new RMCTermsService();
